import { Publication } from '../interfaces/Publication';
// import { useLoadJSON, useLoadJson } from '../hooks/useLoadJson';
import { useState } from 'react';
import { useLoadJson } from '../hooks/useLoadJson';


type PublicationAction =
    | { type: 'change', payload: {publication:Publication}}
    // | { type: 'toggleTodo', payload: {id: string} }

export const PublicationReducer = (state: Publication, action: PublicationAction):Publication =>{

    // const cargarLibro = async (url: string, idPractica: string) => {
    //     // console.log(url)
    //     if(url){
    //         const data = await fetch(url,  {mode:'cors'})
    //         const datos = await data.json() as Publication

    //         // loadPublication()
    //         // const { publica } = datos
    //         // const { title, tasks } = data as Data;

    //         console.log(datos)
    //         return{
    //             datos
    //         }
    //     }
    // }


    // const [url, setUrl] = useState<string | null>(null);
    // const [dataPublication, setDataPublication] = useState<Publication | null>(null)
    
    // const {data} = useLoadJson({url:url}, state)

    // // const {data} = useLoadJSON<Publication>( {url:"http://localhost/test/books.json"} )

    switch(action.type){

        case 'change':

            // setUrl("http://localhost/test/books.json");

            // console.log(data)
            // console.log(data)

            // console.log( "Cargando el libro "+ idLibro)

            // cargarLibro("http://localhost/test/books.json", action.payload.id)

            // console.log(action.payload.id)
            // console.log( action.payload.publication )
            return{
                ...action.payload.publication
            }

            // case 'toggleTodo':
            //     return {
            //         ...state,
            //         todos: state.todos.map( ({ ...todo }) => {
            //             if( todo.id === action.payload.id ) {
            //                 todo.completed = !todo.completed;
            //             }
            //             return todo;
            //         })
            //     }

        default:
            return state
    }
}

